const KEY = 'stagery_ref';

if (typeof window !== 'undefined') {
  const ref = new URLSearchParams(window.location.search).get('ref');
  if (ref) localStorage.setItem(KEY, ref.trim().toUpperCase());
}

export function getReferralCode(): string | undefined {
  return (typeof window !== 'undefined' ? localStorage.getItem(KEY) : null) ?? undefined;
}

export function clearReferralCode(): void {
  if (typeof window !== 'undefined') localStorage.removeItem(KEY);
}
